import React from "react";
import Bookmarks from "./Bookmarks";

const BookmarkPage = ({ bookmarks, handleRemoveBookmark }) => {
  return (
    <div className="bookmark-page">
      <Bookmarks
        bookmarks={bookmarks}
        handleRemoveBookmark={handleRemoveBookmark}
      />
    </div>
  );
};

export default BookmarkPage;
